import { Component, OnInit } from '@angular/core';
import { PoBreadcrumb, PoNotificationService } from '@po-ui/ng-components';
import { ChavesAcessoService } from './chaves-acesso.service';

@Component({
  selector: 'app-chaves-acesso',
  templateUrl: './chaves-acesso.component.html',
  styleUrls: ['./chaves-acesso.component.css'],
  standalone: false
})
export class ChavesAcessoComponent implements OnInit {

  // Campos de Chaves de Acesso
  consumerKey: string = '';
  consumerSecret: string = '';

  isLoadingChaves: boolean = false;

  readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Integrações' }, { label: 'Chaves de Acesso' }]
  };

  constructor(
    private readonly chavesAcessoService: ChavesAcessoService,
    private readonly poNotificationService: PoNotificationService
  ) { }

  ngOnInit(): void {
  }

  get isBotaoChavesHabilitado(): boolean {
    const hasConsumerKey = !!this.consumerKey && this.consumerKey.trim() !== '';
    const hasConsumerSecret = !!this.consumerSecret && this.consumerSecret.trim() !== '';
    return hasConsumerKey && hasConsumerSecret;
  }

  atualizarChaves(): void {
    if (!this.isBotaoChavesHabilitado) {
      return;
    }

    this.isLoadingChaves = true;

    this.chavesAcessoService.atualizarChaves(this.consumerKey, this.consumerSecret).subscribe({
      next: (response) => {
        this.isLoadingChaves = false;
        this.poNotificationService.success('Chaves atualizadas com sucesso!');
      },
      error: (error) => {
        this.isLoadingChaves = false;
        console.error('Erro ao atualizar chaves:', error);
        if (error.error?.message) {
          this.poNotificationService.error(error.error.message);
        } else {
          this.poNotificationService.error('Erro ao atualizar as chaves. Por favor, tente novamente.');
        }
      }
    });
  }

}

